import orderService from "_foundation/apis/transaction/order.service";
import { OrderApi } from "@efood-commerce-sdk/typescript-axios-transaction-efood";
import { site } from "_foundationExt/constants/site";
import ensureObject from "tools/ensureObject";
import { determineStoreId } from "./utils";

const orderApiInstance = new OrderApi(undefined, site.transactionContext);

const orderServiceExt = {
  /**
   * load order confirmation data
   * @param parameters {storeId?: string, orderId: string}
   */
  getOrderConfirmation(
    parameters: {
      storeId?: string;
      orderId: string;
    } & Record<string, unknown>
  ) {
    const {
      storeId: paramStoreId,
      orderId,
      ...options
    } = ensureObject(parameters);
    const storeId = determineStoreId(paramStoreId);
    if (!storeId) {
      return Promise.reject();
    }

    return orderApiInstance.findByOrderId(storeId, orderId, options);
  },
};
export default { ...orderService, ...orderServiceExt };
